// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fgoWR","productName":"Table_productName__3dQSR"};